/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { WorkOrderObjectHierarchyDto } from '../model/workOrderObjectHierarchyDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderObjectsHierarchyControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * @endpoint get /work-order/{workOrderId}/objects/hierarchy
   * @param workOrderId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getObjects1(
    workOrderId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<WorkOrderObjectHierarchyDto>>;
  public getObjects1(
    workOrderId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<WorkOrderObjectHierarchyDto>>>;
  public getObjects1(
    workOrderId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<WorkOrderObjectHierarchyDto>>>;
  public getObjects1(
    workOrderId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (workOrderId === null || workOrderId === undefined) {
      throw new Error('Required parameter workOrderId was null or undefined when calling getObjects1.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/work-order/${this.configuration.encodeParam({ name: 'workOrderId', value: workOrderId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/objects/hierarchy`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<WorkOrderObjectHierarchyDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * @endpoint put /work-order/{workOrderId}/workLines/markWorklineAsComplete/{workLineId}
   * @param workOrderId
   * @param workLineId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public markWorklineAsComplete(
    workOrderId: string,
    workLineId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<WorkOrderObjectHierarchyDto>>;
  public markWorklineAsComplete(
    workOrderId: string,
    workLineId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<WorkOrderObjectHierarchyDto>>>;
  public markWorklineAsComplete(
    workOrderId: string,
    workLineId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<WorkOrderObjectHierarchyDto>>>;
  public markWorklineAsComplete(
    workOrderId: string,
    workLineId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (workOrderId === null || workOrderId === undefined) {
      throw new Error('Required parameter workOrderId was null or undefined when calling markWorklineAsComplete.');
    }
    if (workLineId === null || workLineId === undefined) {
      throw new Error('Required parameter workLineId was null or undefined when calling markWorklineAsComplete.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/work-order/${this.configuration.encodeParam({ name: 'workOrderId', value: workOrderId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/workLines/markWorklineAsComplete/${this.configuration.encodeParam({ name: 'workLineId', value: workLineId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<WorkOrderObjectHierarchyDto>>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * @endpoint put /work-order/{workOrderId}/workLines/progress/{progress}
   * @param workOrderId
   * @param progress
   * @param requestBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public updateWorkLineProgress(
    workOrderId: string,
    progress: number,
    requestBody: Array<string>,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<WorkOrderObjectHierarchyDto>>;
  public updateWorkLineProgress(
    workOrderId: string,
    progress: number,
    requestBody: Array<string>,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<WorkOrderObjectHierarchyDto>>>;
  public updateWorkLineProgress(
    workOrderId: string,
    progress: number,
    requestBody: Array<string>,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<WorkOrderObjectHierarchyDto>>>;
  public updateWorkLineProgress(
    workOrderId: string,
    progress: number,
    requestBody: Array<string>,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (workOrderId === null || workOrderId === undefined) {
      throw new Error('Required parameter workOrderId was null or undefined when calling updateWorkLineProgress.');
    }
    if (progress === null || progress === undefined) {
      throw new Error('Required parameter progress was null or undefined when calling updateWorkLineProgress.');
    }
    if (requestBody === null || requestBody === undefined) {
      throw new Error('Required parameter requestBody was null or undefined when calling updateWorkLineProgress.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/work-order/${this.configuration.encodeParam({ name: 'workOrderId', value: workOrderId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/workLines/progress/${this.configuration.encodeParam({ name: 'progress', value: progress, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<WorkOrderObjectHierarchyDto>>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: requestBody,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * @endpoint put /work-order/{workOrderId}/workLine/{workLineId}/quantity/{quantity}
   * @param workOrderId
   * @param workLineId
   * @param quantity
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public updateWorkLineProgress1(
    workOrderId: string,
    workLineId: string,
    quantity: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<WorkOrderObjectHierarchyDto>>;
  public updateWorkLineProgress1(
    workOrderId: string,
    workLineId: string,
    quantity: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<WorkOrderObjectHierarchyDto>>>;
  public updateWorkLineProgress1(
    workOrderId: string,
    workLineId: string,
    quantity: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<WorkOrderObjectHierarchyDto>>>;
  public updateWorkLineProgress1(
    workOrderId: string,
    workLineId: string,
    quantity: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (workOrderId === null || workOrderId === undefined) {
      throw new Error('Required parameter workOrderId was null or undefined when calling updateWorkLineProgress1.');
    }
    if (workLineId === null || workLineId === undefined) {
      throw new Error('Required parameter workLineId was null or undefined when calling updateWorkLineProgress1.');
    }
    if (quantity === null || quantity === undefined) {
      throw new Error('Required parameter quantity was null or undefined when calling updateWorkLineProgress1.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/work-order/${this.configuration.encodeParam({ name: 'workOrderId', value: workOrderId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/workLine/${this.configuration.encodeParam({ name: 'workLineId', value: workLineId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/quantity/${this.configuration.encodeParam({ name: 'quantity', value: quantity, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'double' })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<WorkOrderObjectHierarchyDto>>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * @endpoint put /work-order/{workOrderId}/workLine/{workLineId}/cableLength/{length}/externalLocationId/{locationId}
   * @param workOrderId
   * @param workLineId
   * @param length
   * @param locationId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @deprecated
   */
  public updateWorkLineProgress2(
    workOrderId: string,
    workLineId: string,
    length: number,
    locationId: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<WorkOrderObjectHierarchyDto>>;
  public updateWorkLineProgress2(
    workOrderId: string,
    workLineId: string,
    length: number,
    locationId: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<WorkOrderObjectHierarchyDto>>>;
  public updateWorkLineProgress2(
    workOrderId: string,
    workLineId: string,
    length: number,
    locationId: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<WorkOrderObjectHierarchyDto>>>;
  public updateWorkLineProgress2(
    workOrderId: string,
    workLineId: string,
    length: number,
    locationId: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (workOrderId === null || workOrderId === undefined) {
      throw new Error('Required parameter workOrderId was null or undefined when calling updateWorkLineProgress2.');
    }
    if (workLineId === null || workLineId === undefined) {
      throw new Error('Required parameter workLineId was null or undefined when calling updateWorkLineProgress2.');
    }
    if (length === null || length === undefined) {
      throw new Error('Required parameter length was null or undefined when calling updateWorkLineProgress2.');
    }
    if (locationId === null || locationId === undefined) {
      throw new Error('Required parameter locationId was null or undefined when calling updateWorkLineProgress2.');
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/work-order/${this.configuration.encodeParam({ name: 'workOrderId', value: workOrderId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/workLine/${this.configuration.encodeParam({ name: 'workLineId', value: workLineId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/cableLength/${this.configuration.encodeParam({ name: 'length', value: length, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'double' })}/externalLocationId/${this.configuration.encodeParam({ name: 'locationId', value: locationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<WorkOrderObjectHierarchyDto>>('put', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
      reportProgress: reportProgress,
    });
  }
}
